export interface ITituloClienteSelecionado {
  titulo: string;
  codCliente?: string | null;
}

export interface ITitulosPorCliente {
  codCliente?: string | null;
  titulos: string;
}

export interface IColunaOpcional<C> {
  apos: string;
  coluna: C;
}

export abstract class FinancialInformationHelper {
  static inserirColunasApos<C extends { field?: string }>(colunas: C[], opcionais: IColunaOpcional<C>[]): C[] {
    return colunas.reduce<C[]>((resultado, coluna) => {
      resultado.push(coluna);
      opcionais
        .filter((opcional) => opcional.apos === coluna.field)
        .forEach((opcional) => resultado.push(opcional.coluna));
      return resultado;
    }, []);
  }

  static algumItemPossuiValor<T>(itens: T[], campo: keyof T): boolean {
    return itens.some((item) => {
      const valor = item[campo];
      return valor !== null && valor !== undefined && (valor as unknown) !== '';
    });
  }

  static agruparTitulosPorCliente(itens: ITituloClienteSelecionado[]): ITitulosPorCliente[] {
    const grupos = new Map<string, { codCliente?: string | null; titulos: string[] }>();

    itens.forEach((item) => {
      const chave = item.codCliente || '';
      const grupo = grupos.get(chave);
      if (grupo) {
        grupo.titulos.push(item.titulo);
      } else {
        grupos.set(chave, { codCliente: item.codCliente, titulos: [item.titulo] });
      }
    });

    return Array.from(grupos.values()).map((grupo) => ({
      codCliente: grupo.codCliente,
      titulos: grupo.titulos.join(','),
    }));
  }
}
